// extracted by mini-css-extract-plugin
export default {"container":"not_found_container__JDa0q"};